// ShortsGrid.js
import { connect } from 'react-redux';

import fetchFeeds from '../action/fetchFeeds.js';
import FeedStoryProvider from '../container/FeedStoryProvider.js';
import FeedMessages from '../component/FeedMessages.jsx';

const mapStateToProps = () => {
  return {
    isShorts: true,
  };
};

const mapDispatchToProps = (dispatch, { category, feedUnixTimestamp }) => {
  return {
    fetchFirstPage: (data = {}) =>
      dispatch(
        fetchFeeds({
          limit: 20,
          type: category,
          isAllowSameId: true,
          shouldReplaceIds: true,
          shouldIgnorePage: true,
          shouldSkipLocalCache: true,
          unixTimestamp: feedUnixTimestamp,
          ...data,
        })
      ),
  };
};

export default FeedStoryProvider(
  connect(mapStateToProps, mapDispatchToProps)(FeedMessages)
);
